<template>
  <div class="w-100">
    <slotBase :bg-grey="true">
      <template v-slot:title>
        <titleBar :header-title="'Scan'" @back="back" />
      </template>

      <template v-slot:content>
        <div
          class="main-content p-x-20 mt-3 d-flex flex-column justify-content-center"
        >
          <div v-if="isLoading" class="spinner-overlay">
            <div class="spinner-border text-primary" role="status" />
          </div>

          <div class="camera d-flex justify-content-center zIndexSetting">
            <qrcode-reader @decode="onDecode"></qrcode-reader>
          </div>

          <card-scan />
        </div>
      </template>
      <template v-slot:modal>
        <modalScan ref="modalScan" />
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import cardScan from "../components/cardScan.vue";
import { mapActions, mapState } from "vuex";
import VueJwtDecode from "vue-jwt-decode";
import modalScan from "../components/modal/modalScan.vue";
export default {
  name: "cameraScanner",
  components: {
    modalScan,
    slotBase,
    titleBar,
    cardScan,
  },
  data() {
    return {
      isLoading: false,
      dataEpay: 0,
    };
  },
  computed: {
    ...mapState("scan", {
      layananApiScan: "layananApiScan",
      dataGlobalCustomer: "dataGlobalCustomer",
    }),
  },

  async mounted() {
    this.cameraPermission()
  },

  methods: {
    ...mapActions({
      postLayananScan: "scan/postLayananScan",
      getCustomerGlobal: "scan/getCustomerGlobal",
    }),

    back() {
      this.$router.push({ name: "dashboardUtama" });
    },

    async initData() {
      const tokenData = VueJwtDecode.decode(localStorage.getItem("token"));
      let tokenDataFix = tokenData.id_customer_global;
      await this.getCustomerGlobal(tokenDataFix).then(() => {
        // console.log("dataCustomer:", this.dataGlobalCustomer);
        for (let i = 0; i < this.dataGlobalCustomer.customer.length; i++) {
          const customer = this.dataGlobalCustomer.customer[i];
          if (
            customer.outlet !== null &&
            customer.quota_emoney !== null &&
            customer.quota_emoney.saldo !== 0) {
              if (customer.quota_emoney.jenis_emoney == 2) {
                this.dataEpay += 1;
              } else if (customer.quota_emoney.masa_aktif >= new Date().getTime()) {
                this.dataEpay += 1;
              }
          }
        }
        // console.log(this.dataEpay);
      });
    },

    cameraPermission() {
       navigator.permissions.query({name: 'camera'})
      .then((permissionObj) => {
        console.log(permissionObj.state);
        this.initData()
      })
      .catch((error) => {
        console.log('Got error :', error);
      })
    },

    async onDecode(decodedString) {
      this.isLoading = true;
      // console.log(decodedString);
      if (decodedString === "" || decodedString === null) {
        this.isLoading = false;
      }
      if (decodedString !== "") {
        let dataPagination = {
          limit: 10,
          skip: 0,
          search: "",
        };

        let dataQr = {
          qr: decodedString,
          limit: 10,
          skip: 0,
          search: "layanan",
        };
        await this.postLayananScan(dataQr).then((res) => {
          if (res.status !== 200) {
            this.$toast.error("Mesin Not found", { position: "top" });
            this.isLoading = false;
          } else {
            if (this.dataEpay > 0) {
              // console.log("Success condition met");
              this.$store.commit("scan/addPaginationScan", dataPagination);
              this.$toast.success("Get Layanan Success", { position: "top" });
              this.$router.push({ name: "pilihLayanan", query: dataQr });
              this.isLoading = false;
            } else {
              // console.log("Error condition met");
              this.$toast.error("Quota E-Money or Outlet Not Found", {
                position: "top",
              });
              this.isLoading = false;
              this.$refs.modalScan.open();
            }
          }
        });
      }
    },
  },
};
</script>

<!-- <script>

import { mapState, mapActions } from "vuex";

export default {
  name: "scanPage",
  components: {

  },

  data() {
    return {
      
    };
  },

  computed: {
    ...mapState("scan", {
      layananApiScan: "layananApiScan",
      dataGlobalCustomer: "dataGlobalCustomer",
    }),
  },

  methods: {
    ...mapActions({
      postLayananScan: "scan/postLayananScan",
      getCustomerGlobal: "scan/getCustomerGlobal",
    }),

    autoRefreshPage() {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    },

    back() {
      this.$router.push({ name: "dashboardUtama" });
      location.reload();
    },
  },
};
</script> -->

<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
.zIndexSetting {
  z-index: 1;
}
</style>
